<template>
    <div class="app-container">
      <BjRouteTabs :route-list="ORDER_ABNORMAL_FIVE_ROUTE_LIST" />
      <BjPage ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :radio="radio"
      :before-reset-search="beforeResetSearch"
      :tooltip-config="{ showAll: false, enterable: false }"
      :selection="selection"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
      >
        <template v-slot:baseForm>
            <BjSelectChannelStore :span="colSpan" :query-params="queryParams" :query-props="['channel', 'storeIdList']" multiple />
            <el-col :span="colSpan">
              <el-form-item :label="$t('InternalOrder.No')" prop="orderNo">
                <BjInput v-model="queryParams.orderNo" :placeholder="$t('InternalOrder.No')" @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="colSpan">
              <el-form-item :label="$t('InternalOrder.order')">
                <BjDateRangePicker v-model="queryParamsTime_order" :placeholder="$t('InternalOrder.order')" />
              </el-form-item>
            </el-col>
            <!-- <el-col v-if="$store.getters.cusId" :span="colSpan">
              <el-form-item :label="$t('InternalOrder.Pending')" prop="suspendStatus">
                <BjSelectLov v-model="queryParams.suspendStatus" :placeholder="$t('orderNewPatch.oStatus')" :option-list="ORDER_INTERNAL_HAND_UP_STATUS_LIST" />
              </el-form-item>
            </el-col> -->
            <el-col v-if="!$store.getters.cusId" :span="colSpan">
              <el-form-item :label="$t('billingPage.CustomerName')" prop="cusId">
                <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" />
              </el-form-item>
            </el-col>
        </template>
        <!-- 展示列表 -->
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item" :show-overflow-tooltip="col.prop !== 'bjTableAction' && col.prop !== 'tagsList'">
              <template slot-scope="scope">
                <template v-if="false" />
                <template v-else-if="col.prop == 'cusId'">{{ customerList.bjGet(scope.row.cusId) }}</template>
                <template v-else-if="col.prop === 'outerOrderNo'">
                  <span>{{ scope.row.webReference }}</span>
                  <BjCopyIcon :copy="scope.row.webReference" />
                </template>
                <template v-else-if="col.prop === 'orderHandleStatus'">
                  {{ $t(ORDER_WMS_STATUS_LIST.bjGet(scope.row[col.prop])) }}
                </template>
                <template v-else-if="col.prop === 'failureReason'">
                  {{ $t(LANG_ZH_EN_PS_LIST.bjGet(scope.row[col.prop])) }}
                </template>
                <template v-else-if="col.prop === 'tagsList'">
                  <el-tooltip :content="getTagTooltip(scope.row[col.prop])" :disabled="!getTagTooltip(scope.row[col.prop])" placement="top">
                    <div class="order-tags-tooltip">
                      <BjTagList :tag-code-array="scope.row[col.prop]" size="mini" circle />
                    </div>
                  </el-tooltip>
                </template>
                <template v-else-if="col.prop === 'orderTime'">
                  <span>{{ scope.row[col.prop] | timeOptimization }}</span>
                </template>
                <template v-else-if="col.prop === 'creationDate'">
                  <span>{{ scope.row[col.prop] | timeOperateTwoHour }}</span>
                </template>
                <template v-else-if="col.prop === 'shippingMethod'">
                  <el-tag v-if="['CUSTOMER MANUAL', 'CSG MANUAL', 'PICKUP'].includes(scope.row[col.prop])" type="success">{{ scope.row[col.prop] }}</el-tag>
                  <span v-else>{{ scope.row[col.prop] }}</span>
                </template>
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
              <template #header>
                {{ $t('operationText') }}
                <el-tooltip placement="top">
                  <div slot="content">{{ $t('InternalOrder.ps1') }}</div>
                  <i class="el-icon-question" style="color: #082dc3;"></i>
                </el-tooltip>
              </template>
              <template slot-scope="props">
                <el-button type="text" class="edit-btn" @click="onView(props.row)">{{ $t('viewText') }}</el-button>
                <!-- orderHandleStatus 0-取消中 1-取消成功 2-取消失败 3-编辑中 4-编辑成功 5-编辑失败 -->
                <el-dropdown
                  v-hasDropdownChildren
                  :disabled="[0,2,3,5].includes(props.row.orderHandleStatus) || !props.row.innerOrderNo"
                  @command="command($event, props.row)">
                  <span class="el-dropdown-link">{{ $t('AccountManagement.common.operate') }}<i class="el-icon-arrow-down el-icon--right" /></span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="edit">{{ $t('editText') }} </el-dropdown-item>
                    <el-dropdown-item :disabled="hasUrgentTag(props.row.tagsList)" command="urgent"> {{ $t('urgentText') }} </el-dropdown-item>
                    <el-dropdown-item command="cancel"> {{ $t('cancelText') }} </el-dropdown-item>
                    <el-dropdown-item v-if="!$store.getters.cusId && props.row.sapOrderNo" command="package"> {{ $t('goodsPage.package.edit') }} </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
      <!-- 新增/编辑弹窗 -->
      <DataForm ref="DataForm" @reFresh="reFresh" @batchDeleteApi="batchDeleteApi" />
    </div>
  </template>
  <script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { orderApi } from '@/api';
  import { ORDER_ABNORMAL_FIVE_ROUTE_LIST,
    LANG_ZH_EN_PS_LIST,
    ORDER_WMS_STATUS_LIST,
    ORDER_INTERNAL_HAND_UP_STATUS_LIST,
  } from '@/utils/constants';
  import DataForm from './DataForm.vue';

  const URGENT_TAG_CODE = 'LB1718612626520-1753039007';

  export default {
    name: 'BusinessAbnormalOrderPROCESSINGOrder',
    components: { DataForm },
    mixins: [pageMiXin],
    data() {
      return {
        selection: true,
        colSpan: 4,
        ORDER_ABNORMAL_FIVE_ROUTE_LIST,
        LANG_ZH_EN_PS_LIST,
        ORDER_WMS_STATUS_LIST,
        ORDER_INTERNAL_HAND_UP_STATUS_LIST,
        queryApi: orderApi.getInternalPage,
        // 查询参数
        queryParamsTime_order: [],
        queryParams: {
          orderNo: null,
          orderStartTime: null,
          payEndTime: null,
          channel: null,
          storeIdList: [],
          // suspendStatus: null,
          cusId: null,

          orderStatus: '0',
        },
        labelList1: [
          { label: this.$t('billingPage.CustomerName'), prop: 'cusId', isCheck: true, disabled: false, width: '100' },
          { label: this.$t('InternalOrder.form.number'), prop: 'outerOrderNo', isCheck: true, disabled: false, width: 145 },
          { label: this.$t('InternalOrder.form.wmsOrderNo'), prop: 'sapOrderNo', isCheck: true, disabled: false},
          { label: this.$t('InternalOrder.form.channel'), prop: 'channelTypeMeaning', isCheck: true, disabled: false},
          { label: this.$t('InternalOrder.form.Sales'), prop: 'storeName', isCheck: true, disabled: false},
          { label: this.$t('InternalOrder.form.orderStatusStr'), prop: 'orderStatusStr', isCheck: true, disabled: false },
          { label: this.$t('orderNewPatch.wmsStatus'), prop: 'orderHandleStatus', isCheck: true, disabled: false },
          { label: this.$t('InternalOrder.form.Label'), prop: 'tagsList', isCheck: true, disabled: false, width: '80' },
          { label: this.$t('orderNewPatch.Shipping'), prop: 'shippingMethod', isCheck: true, disabled: false},
          { label: this.$t('orderNewPatch.Ordered'), prop: 'orderTime', isCheck: true, disabled: false },
          { label: this.$t('orderNewPatch.Created'), prop: 'creationDate', isCheck: true, disabled: false},
          { label: this.$t('InternalOrder.form.Product'), prop: 'goodsQuatity', isCheck: true, disabled: false, width: '90'},
          { label: this.$t('InternalOrder.form.document'), prop: 'trackingNumber', isCheck: true, disabled: false },
          { label: this.$t('orderNewPatch.ShippingCost'), prop: 'totalPrice', isCheck: true, disabled: false },
          { label: this.$t('orderNewPatch.Courier'), prop: 'logisticsCompany', isCheck: true, disabled: false },
          { label: this.$t('InternalOrderListcompent.name'), prop: 'receiverName', isCheck: true, disabled: false },
          { label: this.$t('InternalSalesOrderDetails.Customer'), prop: 'serviceRemarks', isCheck: false, disabled: false },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 150 },
        ],
      };
    },
    computed: {
      labelList() {
        return this.$store.getters.cusId ? this.labelList1.filter(item => item.prop != 'cusId') : this.labelList1;
      },
    },
    watch: {
      queryParamsTime_order(v) {
        this.queryParams.orderStartTime = (v || [])[0];
        this.queryParams.orderEndTime = (v || [])[1];
      },
    },
    created() {
      // 预加载标签数据，避免表格每行渲染时重复调用接口
      this.$store.dispatch('values/getTags');
    },
    methods: {
      // 查看
      onView(row) {
        if (!row.innerOrderNo) {
          this.$router.push({
            // 外部订单详情页
            name: 'BusinessThirdOrderCSGView',
            query: { id: '', code: row.outerOrderNo, status: row.totalOrderStatus || 3, type: 'view' },
          });
        } else {
          // orderHandleStatus 0-取消中 1-取消成功 2-取消失败 3-编辑中 4-编辑成功 5-编辑失败
          if (row.orderHandleStatus == 3) {
            this.$router.push({
              // 内部订单编辑页
              name: 'BusinessOrderInternalEditCSG',
              query: { innerOrderNo: row.innerOrderNo, status: row.totalOrderStatus || 3, orderHandleStatus: row.orderHandleStatus, cusId: row.cusId },
            });
          } else {
            this.$router.push({
              // 内部订单详情页
              name: 'BusinessOrderInternalViewCSG',
              query: { id: '', code: encodeURIComponent(row.innerOrderNo), type: 'edit', status: row.totalOrderStatus || 3, orderHandleStatus: row.orderHandleStatus },
            });
          }
        }
      },
      command(text, row) {
        switch (text) {
          case 'edit':
            // 判断是否可以编辑
            orderApi.getOrderSapStatus({ innerOrderNo: encodeURIComponent(row.innerOrderNo) }).then(res => {
              if (res.failed === false) {
                this.$router.push({
                  // 内部订单编辑页
                  name: 'BusinessOrderInternalEditCSG',
                  query: { innerOrderNo: row.innerOrderNo, status: row.totalOrderStatus || 3, orderHandleStatus: row.orderHandleStatus },
                });
              }
            });
            break;
          case 'urgent':
            if (this.hasUrgentTag(row.tagsList)) return;
            // 判断是否可以加急
            orderApi.getOrderSapStatus({ innerOrderNo: encodeURIComponent(row.innerOrderNo) }).then(res => {
              if (res.failed === false) {
                this.urgentOrder(row);
              }
            });
            break;
          case 'cancel':
            // 判断是否可以取消订单
            orderApi.getOrderSapStatus({ innerOrderNo: encodeURIComponent(row.innerOrderNo) }).then(res => {
              if (res.failed === false) {
                this.onDelete(row);
              }
            });
            break;
          case 'package':
            this.onPackage(row);
            break;
        }
      },
      hasUrgentTag(tags) {
        return this.normalizeTags(tags).includes(URGENT_TAG_CODE);
      },
      normalizeTags(tags) {
        if (Array.isArray(tags)) {
          return tags.filter(Boolean);
        }
        if (typeof tags === 'string') {
          return tags.split(',').map(item => item.trim()).filter(Boolean);
        }
        return [];
      },
      getTagTooltip(tags) {
        const tagMap = this.$store.state.values.BJ_TAGS || [];
        return this.normalizeTags(tags)
          .map(code => (tagMap.find(item => item.labelCode == code) || {}).textContent || code)
          .join(' ');
      },
      // 加急
      urgentOrder(row) {
        const orderId = '';
        const orderCode = row.innerOrderNo;
        orderApi.getInternalDetailByIdCode({ orderCode, orderId }).then(e => {
          const orderInfo = e.orderInfoVO || {};
          const tagsList = this.normalizeTags(orderInfo.tags);
          const tags = tagsList.includes(URGENT_TAG_CODE) ? tagsList : tagsList.concat(URGENT_TAG_CODE);
          orderApi.updateOrderBase({ orderId: orderInfo.id, tags: tags.join(',') }).then(res => {
            if (!res.failed) {
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              setTimeout(() => {
                this.reFresh();
              }, 1000);
            }
          });
        });
      },
      // 取消订单
      onDelete(item) {
        this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        })
        .then(() => {
          // 处理中订单3，调用csg订单取消接口；
          orderApi.cancelInternalProccessingOrder({ innerOrderNo: item.innerOrderNo }).then(res => {
            if (res.failed === false) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              setTimeout(() => {
                this.reFresh();
              }, 500);
            }
          });
        });
      },
      /** 包材侧边栏 */
      onPackage(row) {
        this.$refs.DataForm.show(row);
      },
      /** 重置按钮操作 */
      beforeResetSearch() {
        this.queryParamsTime_order = null;
        this.queryParams.storeIdList = null;
        this.queryParams.cusId = null;
        return new Promise(resolve => {
          resolve();
        });
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  ::v-deep .bj-page .el-form-item__label{
    display: none;
  }

  .order-tags-tooltip {
    overflow: hidden;
  }
  </style>
